import { AllOrganizations } from "../../components";

const Organizations = () => {
  return <AllOrganizations />;
};

export default Organizations;
